<template>
    <v-container>
        <v-content justify="center">
            <v-row v-if="folder !== null">
                <v-col cols="12" class="text-center">
                    <v-card class="mx-auto" tile>
                        <v-list flat>
                            <v-list-item-group v-model="item" color="primary">
                                <v-list-item v-for="(item, i) in folder" :key="i" @click="clickElement(item.ID, item.TYPE)">
                                    <v-list-item-icon>
                                        <v-icon  v-if="item.TYPE === 'file'" :color="(files[item.mime]) ? files[item.mime].color : files.other.color">
                                            {{ (files[item.mime]) ? files[item.mime].icon : files.other.icon }}
                                        </v-icon>
                                        <v-icon  v-if="item.TYPE === 'folder'">
                                            mdi-folder
                                        </v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title v-text="item.NAME"></v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action v-if="item.TYPE === 'file'">
                                        <v-icon>mdi-download</v-icon>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-list-item-group>
                        </v-list>
                    </v-card>
                </v-col>
            </v-row>
            <v-row v-else>
                <v-col cols="12" class="text-center">
                    <v-progress-circular :size="70" :width="7" color="orange darken-3" indeterminate></v-progress-circular>
                </v-col>
            </v-row>
        </v-content>
    </v-container>
</template>

<script>
  const getFileType = (fileName) => {
    const audio = ['mp3', 'wav', 'm4a', 'ogg']
    const image = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'tiff']
    const video = ['mp4', 'mov', 'mwv', 'avi']
    const corel = ['cdr']
    const word = ['doc', 'docx', 'rtf', 'odt']
    const excel = ['xls', 'xlsx', 'csv']
    const powerpoint = ['ppt', 'pptx']
    const pdf = ['pdf']
    const zip = ['zip', 'rar', 'tar', '7z']

    let nameBlocks = fileName.split('.')
    let ext = nameBlocks[nameBlocks.length - 1].toLowerCase()

    if(audio.indexOf(ext) > -1) return 'audio'
    if(video.indexOf(ext) > -1) return 'video'
    if(image.indexOf(ext) > -1) return 'image'
    if(corel.indexOf(ext) > -1) return 'corel'
    if(word.indexOf(ext) > -1) return 'word'
    if(excel.indexOf(ext) > -1) return 'excel'
    if(powerpoint.indexOf(ext) > -1) return 'powerpoint'
    if(pdf.indexOf(ext) > -1) return 'pdf'
    if(zip.indexOf(ext) > -1) return 'zip'
    return 'other'
  }
  const b64DecodeUnicode = (str) => {
    return decodeURIComponent(atob(str).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join(''))
  }

  const b64EncodeUnicode = (str) => {
    return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g,
      function toSolidBytes(match, p1) {
        return String.fromCharCode('0x' + p1)
      }))
  }

  export default {
    name: 'ExtFldLink',
    data() {
      return {
        file: null,
        folder: null,
        item: 1,
        items: [
          { text: 'Real-Time', icon: 'mdi-clock' },
          { text: 'Audience', icon: 'mdi-account' },
          { text: 'Conversions', icon: 'mdi-flag' },
        ],
        files: {
          'pdf': {
            color: 'red darken-2',
            icon: 'mdi-file-pdf'
          },
          'text': {
            color: 'blue darken-1',
            icon: 'mdi-file-document-box-outline'
          },
          'book': {
            color: 'red darken-2',
            icon: 'mdi-book-open-variant'
          },
          'word': {
            color: 'blue darken-1',
            icon: 'mdi-file-word',
          },
          'video': {
            color: 'pink darken-3',
            icon: 'mdi-file-video-outline',
          },
          'audio': {
            color: 'deep-purple darken-1',
            icon: 'mdi-file-music-outline',
          },
          'excel': {
            color: 'green darken-2',
            icon: 'mdi-file-excel',
          },
          'powerpoint': {
            color: 'orange darken-2',
            icon: 'mdi-file-powerpoint',
          },
          'corel': {
            color: 'green darken-3',
            icon: 'mdi-draw',
          },
          'image': {
            color: 'amber darken-1',
            icon: 'mdi-file-image-outline',
          },
          'zip': {
            color: 'brown darken-1',
            icon: 'mdi-folder-zip-outline',
          },
          'other': {
            color: 'grey darken-3',
            icon: 'mdi-file',
          },
        },
      }
    },
    methods: {

      clickFolder: async function(id) {
        try {
          const r  = await this.$http.get(`${this.$store.getters.api}v3/bxdrive/structure?id=${id}`)
          this.folder = r.data.map(f => {
            if(f.TYPE === 'file') {
              f.mime = getFileType(f.NAME)
            }
            return f
          })
          console.log('folder', this.folder)
        } catch (e) {
          console.log(e)
        }
      },
      clickElement: async function (id, type) {
        if(type === 'file') {
          await this.clickFile(id)
        } else {
          window.location.href = `https://my.fitauto.ru/extfolder/${b64EncodeUnicode(id)}`
        }
      },
      clickFile: async function(id) {
        try {
          const r  = await this.$http.get(`${this.$store.getters.api}v3/bxdrive/file/${id}`)
          this.file = r.data
          this.file.mbsize = (+(r.data.SIZE) / 1024 / 1024).toFixed(2)
          console.log('file', this.file)
          this.downloadFile()
        } catch (e) {
          console.log(e)
        }
      },
      downloadFile() {
        window.location.href = this.file.DOWNLOAD_URL
      }
    },
    async mounted() {
      await this.clickFolder(b64DecodeUnicode(this.$route.params.folderid))
    }
  }
</script>

<style scoped>

</style>